import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import theme from '../../theme';
import HorizontalNonLinearAlternativeLabelStepper from './stepper.js';
import globalUseStyles from '../../styleHooks';
import { Grid, Typography, Container } from "@material-ui/core";
import careerClasses from './careersStyles'


function CareersProcess() {
  const globalClasses = globalUseStyles();
  const careerStyles = careerClasses();
  return (
    <ThemeProvider theme={theme}>
      <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall}container >
          <Grid className={globalClasses.cardMargin}item xs={12} md={12}  >
            <Typography align="center" variant="h2">What to expect in the hiring process?</Typography>
          </Grid>
        <Grid className={careerStyles.containerStepper} container >
          <HorizontalNonLinearAlternativeLabelStepper/>
        </Grid>
        </Grid>
      </Container>
    </ThemeProvider>

  );
};



export default CareersProcess;